var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar navbar-light bg-light p-0 my-3"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{ name: 'Overview' }}},[_c('img',{attrs:{"src":"/images/R-Cycle_Logo_RGB_300.png","height":"50","alt":"","loading":"lazy"}})]),_c('LoginComponent',{staticClass:"ml-auto"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }